import React from 'react';
import { Box, SkeletonLoader } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectBreakpoint } from 'store/slice/screen';

import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export const TabsPlaceHolder: React.FC<{ element: string; item: number }> = React.memo((props) => {
    // We might want to use variant brand later when Drone.js fix for all whitelabel
    const breakpoint = useSelector(selectBreakpoint);
    const contextItemL = breakpoint.l ? 5 : 3;
    const noOfLoader = breakpoint.xl ? props.item : contextItemL;

    const cms = useSelector(selectCmsFromBootstrap);

    const tabPlaceHolder = Array.from({ length: noOfLoader }, (_, i) => {
        return <SkeletonLoader label={cms[326495]} key={`catLoader-${i}`} shape="rectangle" width="100%" my="4" me={i < noOfLoader - 1 ? '16' : '0'} />;
    });

    return (
        <Box display="flex" maxWidth="1500px" m="auto" py="2" flex={1} data-testid={`${props.element}-placeholder`}>
            {tabPlaceHolder}
        </Box>
    );
});
TabsPlaceHolder.displayName = 'TabsPlaceHolder';
